/** 예산 작성 화면이 금액을 넣을 때 따르는 기준. 정책보기 모달의 단일 소스. */
export interface BudgetPolicyItem {
  title: string;
  paragraphs: string[];
  /** 정책보기에서 따로 두고 연도 값을 고칠 수 있는 묶음. 지금은 수가만 */
  panel?: "suga";
}

export interface BudgetGuideItem extends BudgetPolicyItem {
  /** meal: 주야간·시설만. keep-delete / hide-delete: 삭제 버튼 유무 */
  show?: "meal" | "keep-delete" | "hide-delete";
}

export const BUDGET_POLICY: BudgetPolicyItem[] = [
  {
    title: "저장",
    paragraphs: [
      "마법사로 표에 적용하거나 칸을 고쳐도, 저장을 눌러야 서버에 남습니다.",
      "예산서와 희망이음 양식은 미리 본 뒤 받습니다. 파일은 마지막으로 저장된 예산으로 만들고, 저장하지 않은 수정은 빠집니다. 보수일람도 저장된 내용으로 만들며, 같은 월급이어도 인원만큼 한 명씩 줄을 나눕니다.",
      "표에 적용을 누르면 지금 적은 내용으로 예산 표를 바꿉니다. 아무것도 적지 않았으면 표의 금액이 비워집니다. 자동으로 계산된 돈은 종류별로 묶어 보여 줍니다. 사회보험, 퇴직적립금, 식재료비와 같은 생계비, 시군구보조금과 같은 생계비(보조금)입니다. 세부사항을 열면 하나씩 빼거나 넣을 수 있습니다. 표만 바뀌고, 서버에 남기려면 예산 화면에서 저장을 누릅니다.",
    ],
  },
  {
    title: "수가",
    panel: "suga",
    paragraphs: [
      "방문요양은 시간대 수가를 씁니다. 등급은 인원을 나누는 이름이고, 시간대를 고르지 않으면 180분 단가로 계산합니다.",
      "방문목욕은 차량 이용(차량 안), 차량 이용(가정 안), 차량 미이용으로 나뉩니다.",
      "주야간보호는 이용 시간과 등급으로 나뉩니다. 3~5등급은 3등급 단가입니다. 4등급, 5등급, 인지지원등급은 행을 나눠 적습니다.",
      "요양시설과 공동생활가정은 등급 수가입니다. 3~5등급은 3등급 단가입니다.",
    ],
  },
  {
    title: "본인부담금과 장기요양급여",
    paragraphs: [
      "두 항목은 한 쌍입니다. 같은 순서의 행끼리 구간, 횟수, 인원, 개월이 같이 움직입니다.",
      "본인부담금은 수가의 본인부담 단가에 월 횟수를 곱합니다. 장기요양급여는 급여 단가에서 본인부담 단가를 뺀 금액에 월 횟수를 곱합니다. 연간 금액은 그 단가에 인원과 12개월을 곱합니다.",
      "기본 월 횟수는 방문요양 26회, 방문목욕 5회, 주야간보호 25회, 요양시설과 공동생활가정 30회입니다. 횟수는 고칠 수 있습니다.",
    ],
  },
  {
    title: "기초수급자",
    paragraphs: [
      "주야간보호, 요양시설, 공동생활가정에서 일반 어르신과 따로 셉니다.",
      "본인부담금은 0원입니다. 장기요양급여는 수가 전액입니다.",
    ],
  },
  {
    title: "대표자",
    paragraphs: [
      "센터장(대표자)는 국민연금, 건강보험, 장기요양보험, 고용보험, 산재보험, 퇴직적립금을 모두 넣지 않습니다.",
      "요양보호사(대표자)와 사회복지사(대표자)는 퇴직적립금, 고용보험, 실업급여, 산재보험을 넣지 않습니다. 국민연금, 건강보험, 장기요양보험은 계산합니다.",
    ],
  },
  {
    title: "사회보험과 퇴직적립금",
    paragraphs: [
      "자동일 때는 월급에 인원을 먼저 곱하고, 그 해 사업주 요율을 적용한 뒤 반올림합니다. 그 금액에 개월을 곱합니다. 장기요양보험은 건강보험료에 요율을 곱해 반올림합니다.",
      "퇴직적립금은 월급 × 인원 × 개월 ÷ 12 를 한 번만 반올림합니다.",
      "단가 칸은 한 사람 기준입니다. 단가 × 인원 × 개월과 금액이 원 단위로 다를 수 있습니다. 금액란과 합계는 위에서 반올림한 금액을 씁니다.",
      "수동일 때는 적은 단가, 인원, 개월을 그대로 곱하고, 자동 계산으로 바꾸지 않습니다.",
    ],
  },
  {
    title: "인건비 지출 비율",
    paragraphs: [
      "인건비 지출은 직접비 급여와 그에 붙은 사회보험, 퇴직적립금입니다. 센터장처럼 간접비로 둔 월급은 비율에서 뺍니다.",
      "나누는 수입은 본인부담금, 인건비 비율에 넣는 장기요양급여, 요양급여 가산금입니다. 장기근속수당, 보수교육비, 선임수당은 비율에 넣지 않습니다.",
      "기준 비율은 그 해에 정해 둔 값입니다. 정해 둔 값이 없으면 60%입니다.",
    ],
  },
  {
    title: "기타잡비",
    paragraphs: [
      "세입과 세출의 차이를 기타잡비로 만들지 않습니다. 기타잡비는 적은 금액만 들어갑니다.",
      "차이가 있으면 리모컨과 마법사에 그 차액이 그대로 남습니다.",
    ],
  },
  {
    title: "식재료비와 생계비",
    paragraphs: [
      "주야간보호, 요양시설, 공동생활가정에서 식재료비 수입을 적으면, 같은 금액을 세출 생계비로 넣는 항목이 표에 적용 목록에 나옵니다. 생계비를 이미 적었으면 그 항목은 빠져 있습니다.",
      "주야간보호의 시군구보조금, 요양시설·공동생활가정의 기초수급자 생계비보조금은 같은 금액을 생계비(보조금)으로 넣는 항목이 나옵니다. 생계비(보조금)을 이미 적었으면 빠져 있습니다.",
      "명절위로금, 특별위로금, 독감예방접종 보조금은 생계비로 복사하지 않습니다. 기타비급여를 의료비로 복사하지도 않습니다.",
      "예산표의 식재료비 반영도 같습니다. 식재료비는 생계비로, 시군구보조금은 생계비(보조금)으로 넣으며, 진행에 동의한 뒤에만 들어갑니다.",
    ],
  },
  {
    title: "전년도이월금",
    paragraphs: [
      "방문요양과 방문목욕은 전년도이월금 한 금액입니다.",
      "주야간보호, 요양시설, 공동생활가정은 보조금, 후원금, 식재료비, 운영비로 나눕니다. 보조금 잔액은 전년도이월금에 보조금으로 넣습니다.",
    ],
  },
  {
    title: "개월",
    paragraphs: [
      "한 달 금액으로 묻는 항목은 12개월을 곱합니다. 연간 금액은 한 번만 넣습니다.",
      "월 금액에 개월을 적을 수 있는 항목은 적은 개월을 쓰고, 비우면 12개월입니다.",
    ],
  },
  {
    title: "사업마다 다른 질문",
    paragraphs: [
      "없는 칸은 비워 둡니다. 금액이 없는 항목은 예산 줄로 만들지 않습니다.",
      "사무실 월 임차료는 방문요양, 방문목욕, 주야간보호만 묻습니다.",
      "처우개선비는 주야간보호, 요양시설, 공동생활가정에서만 묻습니다. 대상 인원, 보조금으로 받은 한 사람 금액, 본인부담 금액을 나눠 적고 12개월을 곱합니다.",
    ],
  },
  {
    title: "복사",
    paragraphs: [
      "본예산의 전년도 복사는 전년도 마지막 차수를 가져옵니다. 지금 본예산은 지워집니다. 급여는 그대로 두고, 퇴직적립금과 사회보험은 올해 요율로 다시 계산합니다. 본인부담금과 장기요양급여는 가져오지 않습니다.",
      "추경의 직전 차수 복사는 직전 시트 항목을 그대로 덮어씁니다. 보험·식재료비·수가를 새로 만들어 넣지 않습니다.",
    ],
  },
];

export const BUDGET_GUIDE: BudgetGuideItem[] = [
  {
    title: "화면",
    paragraphs: ["관·항·목에 맞춰 세입과 세출을 적고 저장합니다."],
  },
  {
    title: "예산 마법사",
    paragraphs: [
      "등급별 인원, 수입, 급여, 지출을 순서대로 적습니다. 없는 칸은 비워도 됩니다.",
      "오른쪽 위의 모두 지우기는 적은 내용과 임시저장을 지웁니다. 표로 되돌리기는 예산 표에 적힌 값으로 다시 엽니다. 예산 표 자체는 둘 다 바꾸지 않습니다.",
      "표에 적용을 누르면 지금 적은 내용으로 예산 표를 바꿉니다. 아무것도 적지 않았으면 표의 금액이 비워집니다. 자동으로 계산된 돈은 종류별로 묶어 보여 줍니다. 세부사항을 열면 하나씩 빼거나 넣을 수 있습니다. 적용한 뒤 저장해야 서버에 남습니다.",
    ],
  },
  {
    title: "연도와 보기",
    paragraphs: [
      "연도는 리모컨 위쪽에서 바꿉니다.",
      "전체, 세입, 세출 중에서 볼 표를 고릅니다.",
      "산출기초에서 세입, 세출, 차액과 인건비 지출 비율을 확인합니다.",
    ],
  },
  {
    title: "저장과 삭제",
    show: "keep-delete",
    paragraphs: [
      "현재 연도, 차수, 사업구분 단위로 한 번에 저장하거나 전체 삭제합니다.",
      "저장하지 않고 다른 화면으로 가거나 창을 닫으면, 저장하고 나갈지 묻습니다. 연도나 추경 차수를 바꿀 때도 같습니다.",
    ],
  },
  {
    title: "저장",
    show: "hide-delete",
    paragraphs: [
      "현재 연도, 차수, 사업구분 단위로 한 번에 저장합니다. 전체 삭제는 추경관리에서 합니다.",
      "저장하지 않고 다른 화면으로 가거나 창을 닫으면, 저장하고 나갈지 묻습니다. 연도나 추경 차수를 바꿀 때도 같습니다.",
    ],
  },
  {
    title: "표에서 고치기",
    paragraphs: [
      "본인부담금과 장기요양급여는 한 쌍입니다. 수가 구간이나 횟수를 바꾸면 그 행과 같은 순서의 짝 행에 같은 구간, 횟수, 인원, 개월이 들어갑니다. 화면을 열 때는 저장된 금액을 그대로 둡니다.",
      "급여 종류를 고르면 사회보험과 퇴직이 같은 묶음이 됩니다. 자동이면 그 해 요율로 계산하고, 수동으로 바꾸면 직접 고칩니다.",
      "목 이름을 두 번 누르면 내용란에 들어갑니다. 급여, 본인부담, 장기요양급여 목은 빠집니다.",
    ],
  },
  {
    title: "추경",
    paragraphs: [
      "위쪽 탭에서 본예산과 추경 차수를 바꿉니다. 추경관리에서 직전 시트를 그대로 둘지, 빈 시트로 시작할지 고릅니다. 그대로 두면 적혀 있던 항목만 옮기고, 보험·식재료비·수가를 새로 만들어 넣지 않습니다.",
      "다음 차수는 저장된 마지막 번호의 다음만 만들 수 있습니다. 마지막 차수를 지우면 그 번호가 비고, 다시 만들 때 같은 번호를 씁니다.",
      "추경 전체 삭제는 가장 큰 차수부터 순서대로 할 수 있습니다.",
    ],
  },
  {
    title: "복사와 내려받기",
    paragraphs: [
      "전년도예산복사는 본예산에서 전년도 마지막 차수를 가져옵니다. 지금 본예산은 지워집니다. 급여는 유지하고, 퇴직과 사회보험은 올해 요율로 다시 계산합니다. 본인부담금과 장기요양급여는 가져오지 않습니다.",
      "최근예산복사는 추경에서 직전 차수 항목을 현재 시트에 그대로 덮어씁니다. 보험·식재료비·수가를 새로 만들어 넣지 않습니다.",
      "예산서와 희망이음 양식은 미리 본 뒤 받습니다. 파일은 저장된 내용으로 만들고, 저장하지 않은 수정은 빠집니다. 보수일람도 저장된 내용으로 만들며, 같은 월급이어도 인원만큼 한 명씩 줄을 나눕니다.",
    ],
  },
  {
    title: "식재료비 반영",
    show: "meal",
    paragraphs: [
      "주야간보호와 시설에서, 세입 식재료비와 같은 금액을 세출 생계비로, 시군구보조금과 같은 금액을 생계비(보조금)으로 넣습니다. 진행에 동의한 뒤 들어가고, 저장해야 서버에 남습니다.",
    ],
  },
];
